import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  loadingState: false,
};

const LoadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    startLoading: (state) => {
      state.loadingState = true;
    },
    endLoading:(state) =>{
        state.loadingState = false
    }

  },
});

export const {
    startLoading,
    endLoading
} = LoadingSlice.actions;

export default LoadingSlice.reducer;
